export default class StockAllocationError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'StockAllocationError';

        Object.setPrototypeOf(this, StockAllocationError.prototype);
    }
}
